// extracted by mini-css-extract-plugin
export default {"icon":"index_icon__f5trP"};